import { memoizeFunction } from '@fluentui/react/lib/Utilities';

/**
 * This memoized function helps prevent unnecessary renders. It would still be correct to have
 * just the return value, but it would be a new reference every time which would trigger re-renders
 */
export const memoizedDismissMenu = memoizeFunction((dismissMenu: (ev?: any, dismissAll?: boolean) => void) => {
  return () => dismissMenu(undefined, true);
});
